module.exports = __webpack_public_path__ + "img/close-btn.810a2efd.svg";